import { CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const ButtonSecondary = (props) => {
  const { text, onClick, className, loading, submit, iconLeft, iconRight, size, link } = props;
  return link ? (
    <Link className={`btn-secondary ${size} ${className}`} onClick={onClick} href={link}>
      <p>{text}</p>
    </Link>
  ) : (
    <button type={submit ? "submit" : "button"} className={`btn-secondary ${size} ${className}`} onClick={onClick}>
      {loading ? (
        <div className="icon-left">
          <CircularProgress size={size === "sm" ? "1.25rem" : size === "md" ? "1.5rem" : "2rem"} />
        </div>
      ) : iconLeft ? (
        <div className="icon-left">{iconLeft}</div>
      ) : null}
      <p>{text}</p>
      {iconRight && <div className="icon-right">{iconRight}</div>}
    </button>
  );
};

export default ButtonSecondary;
